import type { ReactNode } from "react";
import { twMerge } from "@/lib/twMerge";
import { FIELD_STYLES } from "@/lib/fieldStyles";

interface Props {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  children: ReactNode;
}

/** A plain native `<select>`, styled to match TextField — registry-editor.html styles
 * `input`, `textarea`, and `select` with one joint rule rather than giving a dropdown
 * a heavier custom-listbox treatment. Right for a closed, short option list; a real
 * combobox would be the wrong tool here, not a shortcut. */
export function Select({ label, value, onChange, placeholder, className, children }: Props) {
  return (
    <label className={twMerge("flex flex-col gap-[5px]", className)}>
      {label && <span className="text-xs text-text/70">{label}</span>}
      <select value={value} onChange={(e) => onChange(e.target.value)} className={twMerge(FIELD_STYLES, "bg-bg")}>
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {children}
      </select>
    </label>
  );
}
